import React, { CSSProperties, ReactElement } from 'react'
import { Image, userLoading } from 'Components/view-image'
import Link from 'next/link'
import classNames from 'classnames'
import { Wrapper } from 'lib/noop-wrapper'
import { isNewVersion } from 'Components/hooks/use-version'
import styleModule from './avatar.module.scss'

export interface IUgcUserLinkParams {
  userId?: string
  username?: string
  target?: string
  tab?: 'gzyh'
}

export function ugcUserLink({
  userId,
  username,
  target = '_blank',
  tab,
}: IUgcUserLinkParams): Wrapper {
  const title = username ? `${username}个人主页 ` : undefined
  const asPath = `/user${tab ? `/${tab}` : ''}/${userId}`

  const withLink: Wrapper = (content) =>
    userId ? (
      <Link
        href={
          isNewVersion()
            ? `/new_profile?theUserId=${userId}`
            : `/profile?theUserId=${userId}`
        }
        as={asPath}
      >
        <a target={target} title={title}>
          {content}
        </a>
      </Link>
    ) : (
      // eslint-disable-next-line no-script-url
      <a href="javascript:;">{content}</a>
    )

  const normal: Wrapper = (content) =>
    userId ? (
      <a href={asPath} title={title} target={target}>
        {content}
      </a>
    ) : (
      content
    )

  return target === '_self' ? withLink : normal
}

export interface IProps {
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
  avatar?: string // 用户头像 url
  userId?: string // 用户id
  username?: string // 用户名
  userVerified?: boolean // 用户认证
  verifyType?: number // 用户认证类型
  size?: number
  verifySize?: number
  hoverTransition?: boolean
  style?: CSSProperties
  className?: string
  displayName?: boolean
}

const Avatar: React.FC<IProps> = ({
  onClick,
  avatar = '',
  userVerified = false,
  verifyType = 1,
  userId,
  username,
  size = 40,
  verifySize = 12,
  hoverTransition,
  style,
  className,
  displayName = false,
}) => {
  return (
    <div
      className={classNames(styleModule['avatar-img'], 'tw-text-0', className)}
      style={{ ...style }}
      onClick={onClick}
    >
      {ugcUserLink({ userId, username })(
        <React.Fragment>
          <Image
            src={avatar}
            alt={`${username || ''}头像`}
            className="avatar tw-rounded-full"
            lazy={true}
            width={size}
            height={size}
            autoPixelRatio
            cusDefaultImg={userLoading}
            hoverTransition={hoverTransition}
          />
          {userVerified ? (
            <i
              className={classNames(styleModule['author-v'], 'author-v', {
                'v-yellow': verifyType === 1,
                'v-blue': verifyType === 2,
              })}
            />
          ) : null}
          {displayName && <span className="avatar-name">{username}</span>}
        </React.Fragment>
      )}
      <style jsx>
        {`
          .v-yellow {
            background-image: url(${require('static/v-y.svg')});
          }
          .v-blue {
            background-image: url(${require('static/v_blue_24.png')});
          }
          .author-v {
            width: ${verifySize}px;
            height: ${verifySize}px;
          }
        `}
      </style>
    </div>
  ) as ReactElement
}

export default Avatar
